"use strict";

var _slicedToArray = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/runner/work/es-product-index/es-product-index/node_modules/@babel/runtime/helpers/classCallCheck");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var vendorfragments_json_1 = __importDefault(require("../../fixtures/regexes/vendorfragments.json"));

var user_agent_1 = require("../../utils/user-agent");

var VendorFragmentParser = function VendorFragmentParser() {
  _classCallCheck(this, VendorFragmentParser);

  this.parse = function (userAgent) {
    for (var _i = 0, _Object$entries = Object.entries(vendorfragments_json_1.default); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          brand = _Object$entries$_i[0],
          vendorFragment = _Object$entries$_i[1];

      var _iterator = _createForOfIteratorHelper(vendorFragment),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var regex = _step.value;
          var match = user_agent_1.userAgentParser(regex, userAgent);
          if (!match) continue;
          return brand;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return "";
  };
};

exports.default = VendorFragmentParser;